export default {
  comments: [],
  totalComments: 0,
  loading: false
}